import { createSlice } from "@reduxjs/toolkit";

const customerInteractionSlice = createSlice({
  name: "customerInteraction",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {
    getCustomerInteractionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getCustomerInteractionSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getCustomerInteractionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getCustomerInteractionRequest,
  getCustomerInteractionSuccess,
  getCustomerInteractionFailure,
} = customerInteractionSlice.actions;

export default customerInteractionSlice.reducer;
